



































































































































































































































































































import Vue from "vue";
import store, { BankStatementStore } from "../services/BankStatementStore";
import { bankStatementDefaultProps } from "../models/BankStatement";
import bStore, { BankStore } from "../../bank/services/BankStore";
import { NumericTextBox } from "@progress/kendo-vue-inputs";
import MoneyInput from "@/components/MoneyInput.vue";
import BankStatementPicturePage from "./BankStatementPicture.vue";
import dayjs from "dayjs";
import configuration, { AppConfiguration } from "@/models/Configuration";
import { ValidationFunc } from "@/models/Validation";
import DateInput from "@/components/DateInput.vue";
import SpecialDimensionButton from "@/components/SpecialDimensionButton.vue";
import BankStatementApi from "../services/BankStatementApi";
import ConfirmationBox from "@/components/ConfirmationBox.vue";
import BankDocByInvoices from "./BankDocByInvoices.vue";
import eventBus from "@/services/eventBus";

interface Data {
  store: BankStatementStore;
  bStore: BankStore;

  configuration: AppConfiguration;
  dateRule: Array<ValidationFunc>;
  valid: boolean;
  confirmation: boolean;
  wrongConfirmation: boolean;
  creatingDocFromInvoice: boolean;
}

interface Methods {
  save(): void;
  cancel(): void;
  bankCodeChanged(): void;
  onInput(value: Date): void;
  loadCloseRate(): void;
  loadLastBalance(): void;
  close(): void;
  closeInner(updateBalance: boolean): void;
  reopen(): void;
  setWrong(): void;
}

interface Computed {
  statusName: string;
  accountingStatusName: string;
  bankName: string;
  isDisabled: boolean;
  isWrongDisabled: boolean;
  isReopenDisabled: boolean;
  isTechnicalBank: boolean;
  balanceAll: number;
  defaultCurrency: string;
  edateStatement: Date;
}

export default Vue.extend<Data, Methods, Computed, {}>({
  async beforeMount() {
    store.loadBankStatuses();
    store.loadBankAccountStatuses();

    if (this.store.bankStatement.id > 1){
      await this.store.loadBankDocumentsByStatementId(
        this.store.bankStatement.id
      );

      if (this.store.bankStatement.openRate == 0){
        this.loadCloseRate();
      }
    }
  },

  components: {
    NumericTextBox,
    MoneyInput,
    BankStatementPicturePage,
    DateInput,
    ConfirmationBox,
    BankDocByInvoices,
    SpecialDimensionButton
  },

  data() {
    return {
      edate: new Date(),
      store,
      bStore,
      configuration,
      dateRule: [
        (v: Date | string) => !!v || "Kötelező kitölteni!",
        (v: Date | string) =>
          (v && dayjs(v).toDate() >= dayjs("2016-06-15").toDate()) ||
          "Nem lehet régebbi a dátum, mint 2016-06-15",
        (v: Date | string) =>
          (v && dayjs(v).toDate().getDate() >= dayjs().toDate().getDate()) ||
          "Nem lehet a mai napnál későbbi dátum!",
      ],
      valid: false,
      confirmation: false,
      wrongConfirmation: false,
      creatingDocFromInvoice: false,
    };
  },

  computed: {
    defaultCurrency(){
      return (configuration.sysParams.defaultCurrency as any).value;
    },

    balanceAll(){
      if (this.store.bankStatement.currency != this.defaultCurrency){
        return this.store.bankDocuments.filter(x => x.status.toLocaleLowerCase() != "rontott").map(x => x.bankStatementItem.currAmount * (x.bankStatementItem.crediting ? 1 : -1)).reduce((sum, x) => sum += x, 0) + this.store.bankStatement.openBalance;
      }

      return this.store.bankDocuments.filter(x => x.status.toLocaleLowerCase() != "rontott").map(x => x.bankStatementItem.amount * (x.bankStatementItem.crediting ? 1 : -1)).reduce((sum, x) => sum += x, 0) + this.store.bankStatement.openBalance;
    },

    isDisabled(){
      return this.store.bankStatement.status == 3 || this.store.bankStatement.status == 4 || this.store.bankStatement.isReopen;
    },

    isTechnicalBank(){
      return this.store.partBanks.find(x => x.id == this.store.bankStatement.bank)?.technical ?? false;
    },

    isReopenDisabled(){
      if (this.store.bankStatement.status != 3){
        return true;
      }

      // Technikai banknál (0 egyenleg) bármelyik kivonat visszanyitható,
      // devizás és főkönyvi megkötés nélkül
      if (this.isTechnicalBank){
        return false;
      }

      const accountStatus = this.store.bankStatement.accountStatus;
      const isSent = accountStatus == 4 || accountStatus == 6 || accountStatus == 9 || accountStatus == 10;

      // Csak lezárt, főkönyvbe még fel nem adott, HUF-os kivonat nyitható vissza
      return isSent
        || this.store.bankStatement.currency != this.defaultCurrency;
    },

    isWrongDisabled(){
      const accountStatus = this.store.bankStatement.accountStatus;
      const isSent = accountStatus == 4 || accountStatus == 6 || accountStatus == 9 || accountStatus == 10;
      const allItemsWrong = this.store.bankDocuments.every(x => x.status.toLocaleLowerCase() == "rontott");

      return this.store.bankStatement.id < 2
        || this.store.bankStatement.status == 3
        || this.store.bankStatement.status == 4
        || (isSent && !this.isTechnicalBank) // technikai banknál a főkönyvi feladást nem kell ellenőrizni
        || !allItemsWrong;
    },

    statusName() {
      return this.store.bankStatuses.find(x => x.id == this.store.bankStatement.status)?.name ?? "";
    },
    accountingStatusName() {
      return this.store.bankAccountStatuses.find(x => x.id == this.store.bankStatement.accountStatus)?.name ?? "";
    },
    bankName() {
     return this.store.partBanks.find(
          (x) => x.id == this.store.bankStatement.bank
        )?.bank ?? "";
    },
    edateStatement(){
      return this.store.bankStatement.edate;
    }
  },

  methods: {
    async closeInner(updateBalance){
      this.confirmation = false;

      if (!updateBalance){
        return;
      }

      await this.store.closeBankStatement(true);
    },

    async setWrong(){
      this.wrongConfirmation = false;
      await this.store.wrongBankStatement();
    },

    async reopen(){
      const result = await this.store.reopenBankStatement();
      if (result) {
        eventBus.$emit("success", "Sikeres visszanyitás!");
      }
    },

    async close(){
      console.log((Math.round(this.balanceAll * 100) / 100));

      if ((Math.round(this.balanceAll * 100) / 100) != this.store.bankStatement.closeBalance){
        this.confirmation = true;
      } else {
        this.closeInner(true);
      }
    },

    async loadCloseRate(){
      if (this.store.bankStatement.bank > 1 && this.store.bankStatement.currency != 'HUF') {
        this.store.bankStatement.openRate = await BankStatementApi.getLastStatementRate(this.store.bankStatement.bank, this.store.bankStatement.id, this.store.bankStatement.edate);
      } else {
        this.store.bankStatement.openRate = 1;
      }
    },

    async loadLastBalance(){
      if (this.store.bankStatement.bank > 1 /*&& this.store.bankStatement.openBalance == 0*/){
        this.store.bankStatement.openBalance = await BankStatementApi.getLastBalance(this.store.bankStatement.bank, this.store.bankStatement.id, this.store.bankStatement.edate);
      }
    },

    onInput(value: Date) {
      if (value) {
        this.store.bankStatement.edate = value;
      } else {
        this.store.bankStatement.edate = new Date;
      }
    },

    cancel() {
      this.store.bankStatement = { ...bankStatementDefaultProps };
      this.$router.push(`/bank-statement`);
    },

    async save() {
      const id = Number(await this.store.save());
      if (id > 1) {
        this.$router.push(`/bank-statement/create/${id}/head`); //todo
      }
    },

    bankCodeChanged() {
      this.store.bankStatement.currency =
        this.store.partBanks.find(
          (x) => x.id == this.store.bankStatement.bank
        )?.currency ?? "-";

      this.store.bankStatement.bank =
        this.store.partBanks.find(
          (x) => x.id == this.store.bankStatement.bank
        )?.id ?? 1;

      this.loadCloseRate();
      this.loadLastBalance();
    },
  },

  watch:{
    edateStatement: function(){
      this.loadCloseRate();
      this.loadLastBalance();
    }
  },
});
